import api, { ensureCsrfCookie } from "../axiosConfig";

export async function startEmbeddedSignup(payload) {
  await ensureCsrfCookie();
  const { data } = await api.post("/omnichannel/whatsapp-lines/embedded-signup/start", payload);
  return data.data;
}

export async function getEmbeddedSignupSession(sessionKey) {
  await ensureCsrfCookie();
  const { data } = await api.get(`/omnichannel/whatsapp-lines/embedded-signup/session/${sessionKey}`);
  return data.data;
}

export async function finalizeEmbeddedSignup(payload) {
  await ensureCsrfCookie();
  const { data } = await api.post("/omnichannel/whatsapp-lines/embedded-signup/finalize", payload);
  return data.data;
}

export async function cancelEmbeddedSignup(payload) {
  await ensureCsrfCookie();
  const { data } = await api.post("/omnichannel/whatsapp-lines/embedded-signup/cancel", payload);
  return data.data;
}
